import { useRef, useState } from 'react';
import { css, keyframes } from 'styled-components';

const oddsUp = keyframes`
  0% {
    opacity: 0;
		transform: translate(-5px, 5px);
  }
  50% {
    opacity: 1;
		transform: translate(3px, -3px);
  }
	100% {
		opacity: 0;
		transform: translate(3px, -3px);
	}
`;

const oddsDown = keyframes`
  0% {
    opacity: 0;
		transform: translate(5px, -5px);
  }
  50% {
    opacity: 1;
		transform: translate(-3px, 3px);
  }
	100% {
		opacity: 0;
		transform: translate(-3px, 3px);
	}
`;

// Define base styles and variations
const baseStyles = css`
	position: relative;
	content-visibility: auto; // doesn't work for safari
	contain: content;

	&::after {
		content: '';
		position: absolute;
		display: block;
		z-index: 0;
		border-style: solid;
		opacity: 0;
	}
`;

const stylesUp = css`
	${baseStyles}
	&::after {
		top: 3px;
		right: 3px;
		border-width: 14px 0 0 14px;
		border-color: rgba(var(--success), 1) transparent transparent transparent;
		animation: ${oddsUp} 1s 0s 3 normal forwards;
	}
`;

const stylesDown = css`
	${baseStyles}
	&::after {
		bottom: 3px;
		right: auto;
		left: 3px;
		top: auto;
		border-width: 0 14px 14px 0;
		border-color: transparent transparent rgba(var(--error), 1) transparent;
		animation: ${oddsDown} 1s 0s 3 normal forwards;
	}
`;

/**
 * Use this hook to animate selection button when odds change. Pass resulting styles to the styled component.
 */
const useOddsChangeStyles = (odds: number, durationMs = 3000) => {
	const prevOdds = useRef(odds);
	const [oddsChanged, setOddsChanged] = useState<'up' | 'down' | null>(null);

	if (prevOdds.current !== odds) {
		setOddsChanged(odds > prevOdds.current ? 'up' : 'down');
		prevOdds.current = odds;
		// Reset oddsChanged after the animation
		setTimeout(() => setOddsChanged(null), durationMs);
	}

	return (oddsChanged && (oddsChanged === 'up' ? stylesUp : stylesDown)) || baseStyles;
};

export default useOddsChangeStyles;
